// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0864d157","977":"a8bba47c"}[chunkId] + ".chunk.js";
};